
import { StorageService } from "../services/storage.service";
import * as Constants from "../utils/Constants";
import { DIMENSION_CONSTANTS } from "../utils/Constants";

export function calcPsi(name: string): number {
    const data_muntin_spacer = Constants.data_muntin_spacer;
    let result = 0.0;

    if (name && name.trim() !== '') {
        for (let i = 0; i < data_muntin_spacer.length; ++i) {
            if (data_muntin_spacer[i].name === name) {
                result = data_muntin_spacer[i].psi;
                break;
            }
        }
    }

    return result;
}
export function calcDeltaUw(currentproject: any): number {
    let result = 0.00;
    const proj = currentproject;
    let muntin;

    if (proj?.muntin)
        muntin = proj.muntin;

    let sumMuntins = 0;

    if (muntin?.shape?.id !== 1) {
        if (muntin?.type?.id == 4) {
            result = 0.40;
        } else if (muntin?.spacer === 'MUNTINSPACER_FIXED_ADDITION') {
            sumMuntins += muntin.shape.countHorizontal;
            sumMuntins += muntin.shape.countVertical;

            // einfaches Kreuz
            if (sumMuntins > 0 && sumMuntins <= 2) {
                result = 0.10;
            }
            // mehrfaches Kreuz
            else if (sumMuntins > 2) {
                result = 0.20;
            }
        }
    }

    return result;
}

export function muntinSpacerExists(name: any) {
    var result = false,
        i;

    for (i = 0; i < Constants.data_muntin_spacer.length; ++i) {
        if (Constants.data_muntin_spacer[i].name === name) {
            result = true;
            break;
        }
    }

    return result;
};

export async function setDefaultWindowMuntinSpacer(
    currentRef: any,
    storageService: StorageService,
    isShowConfiguration: any,
    glazingCount?: any,
    muntinShape?: any,
    muntinType?: any,
    isComparisonMode: boolean = false
): Promise<void> {
    const res = isComparisonMode
        ? await storageService.getComparedProject()
        : await storageService.getProject();
    const proj = res ? JSON.parse(res) : null;
    const muntin = proj?.muntin;
    const oldGlazing = proj?.windowglas?.glazingCount;
    const oldShape = muntin?.shape;
    const oldType = muntin?.type;

    // Use provided values or fall back to existing ones
    const targetGlazing = glazingCount || oldGlazing;
    const targetMuntinShape = muntinShape || oldShape;
    const targetMuntinType = muntinType || oldType;
    console.log(targetGlazing, targetMuntinShape, targetMuntinType)
    // If shape is type 1 (likely "none" or "no muntin")
    if (targetMuntinShape.id == 1) {
        muntin.spacer = '';
        muntin.psi = 0.00;
    } else {
        // Check if there was a significant change in configuration
        const shapeChangedToFromType1 = (targetMuntinShape.id != oldShape.id &&
            (targetMuntinShape.id == 1 || oldShape?.id == 1));
        const typeChanged = targetMuntinType.id != oldType?.id;
        const glazingChanged = oldGlazing != targetGlazing;

        if (shapeChangedToFromType1 || typeChanged || glazingChanged) {
            // For certain muntin types, use no spacer
            if (targetMuntinType.id == 1 || targetMuntinType.id == 4) {
                muntin.spacer = '';
                muntin.psi = 0.00;
            } else {

                if (muntin.configType == 'basic') {
                    if (muntin.muntinspacers1 == '0001') {
                        muntin.muntinspacers2 = muntin.muntinspacers2; //0011 - plastic  0001- Aluminium
                        muntin.muntinspacers3 = muntin.muntinspacers3;
                        muntin.muntinspacers4 = muntin.muntinspacers4;
                        if (targetGlazing == 2) {
                            if (muntin.muntinspacers2 == '0011' && muntin.muntinspacers4 == '0001') {
                                muntin.spacer = "MUNTINSPACER_PLASTIC_2MM";
                            } else if (muntin.muntinspacers2 == '0011' && muntin.muntinspacers4 == '1001') {
                                muntin.spacer = "MUNTINSPACER_PLASTIC_4MM";
                            } else if (muntin.muntinspacers2 == '0001' && muntin.muntinspacers4 == '0001') {
                                muntin.spacer = "MUNTINSPACER_ALU_2MM";
                            } else if (muntin.muntinspacers2 == '0001' && muntin.muntinspacers4 == '1001') {
                                muntin.spacer = "MUNTINSPACER_ALU_4MM";
                            }
                        } else if (targetGlazing == 3 && muntin.muntinspacers3 == '0001') {
                            if (muntin.muntinspacers2 == '0011' && muntin.muntinspacers4 == '0001') {
                                muntin.spacer = "MUNTINSPACER_PLASTIC_SINGLE_2MM";
                            } else if (muntin.muntinspacers2 == '0011' && muntin.muntinspacers4 == '1001') {
                                muntin.spacer = "MUNTINSPACER_PLASTIC_SINGLE_4MM";
                            } else if (muntin.muntinspacers2 == '0001' && muntin.muntinspacers4 == '0001') {
                                muntin.spacer = "MUNTINSPACER_ALU_SINGLE_2MM";
                            } else if (muntin.muntinspacers2 == '0001' && muntin.muntinspacers4 == '1001') {
                                muntin.spacer = "MUNTINSPACER_ALU_SINGLE_4MM";
                            }
                        } else if (targetGlazing == 3 && muntin.muntinspacers3 == '0101') {
                            if (muntin.muntinspacers2 == '0011' && muntin.muntinspacers4 == '0001') {
                                muntin.spacer = "MUNTINSPACER_PLASTIC_DOUBLE_2MM";
                            } else if (muntin.muntinspacers2 == '0011' && muntin.muntinspacers4 == '1001') {
                                muntin.spacer = "MUNTINSPACER_PLASTIC_DOUBLE_4MM";
                            } else if (muntin.muntinspacers2 == '0001' && muntin.muntinspacers4 == '0001') {
                                muntin.spacer = "MUNTINSPACER_ALU_DOUBLE_2MM";
                            } else if (muntin.muntinspacers2 == '0001' && muntin.muntinspacers4 == '1001') {
                                muntin.spacer = "MUNTINSPACER_ALU_DOUBLE_4MM";
                            }
                        }
                    } else {
                        muntin.muntinspacers2 = null;
                        muntin.muntinspacers3 = null;
                        muntin.muntinspacers4 = null;
                        muntin.spacer = "MUNTINSPACER_FIXED_ADDITION";
                    }
                } else {

                    // Set appropriate spacer based on glazing type
                    // if (targetGlazing == '2') {
                    //     muntin.spacer = 'MUNTINSPACER_PLASTIC_2MM';
                    // } else if (targetGlazing == '3') {
                    //     muntin.spacer = 'MUNTINSPACER_PLASTIC_SINGLE_2MM';
                    // } else 
                    if (targetGlazing == '4') {
                        muntin.spacer = 'man';
                    }
                }
            }
        }
    }

    // Calculate Psi for certain muntin types
    if ((targetMuntinType.id == 2 || targetMuntinType.id == 3) && muntin.configType == 'basic') {
        muntin.psi = calcPsi(muntin.spacer);
    }

    // Update muntin properties
    muntin.shape = targetMuntinShape;
    muntin.type = targetMuntinType;
    await currentRef.updateStorage(muntin, isShowConfiguration);
}

export interface WindowDimensions {
    a: number;
    b: number;
    c: number;
}

export interface FrameWidths {
    w0: number;
    w1: number;
    w2: number;
    w3: number;
    w4: number;
    w5: number;
    w6: number;
}

/* ===================== AREA CALCULATIONS ===================== */

/**
 * Calculate window area based on window type
 * Reference: calculation.js calcArea()
 */
export function calculateWindowArea(
    windowTypeId: number,
    dimensions: WindowDimensions
): number {
    const { a, b, c } = dimensions;

    // Simple rectangular windows (most common)
    // Types: 1=SingleSash, 2=DoubleSash, 3=TwoParted, 4=TripleSash, 9=FixedLight, 10=Cross, 13/14=variations
    if ([1, 2, 3, 4, 9, 10, 13, 14].includes(windowTypeId)) {
        return (a * b);
    }

    // Windows with dimension C (split windows)
    // Types: 5=VerticalSliding, 6=HorizontalSliding, 7=SingleSashToplight, 8=DoubleSashToplight, 11=DoubleSplit, 12=TripleSplit
    if ([5, 7, 8, 11, 12].includes(windowTypeId)) {
        return (a * (b + c));
    }

    if ([6].includes(windowTypeId)) {
        return ((a + b) * c)
    }

    // Default rectangular
    return (a * b);
}

/**
 * Calculate frame area based on window type
 * Reference: calculation.js calcFrameArea() and Frames.calcExpert* methods
 */
export function calculateFrameArea(
    windowTypeId: number,
    dimensions: WindowDimensions,
    frameWidths: FrameWidths
): number {
    const { a, b, c } = dimensions;
    const { w0, w1, w2, w3, w4, w5, w6 } = frameWidths;

    let frameArea = 0;

    switch (windowTypeId) {
        case 1: // Single sash
        case 9: // Fixed light
            {
                const aInner = a - w0;
                const a0 = b * w0 * 2 - w0 * w1 - w0 * w2;
                const a1 = aInner * w1;
                const a2 = aInner * w2;
                frameArea = a0 + a1 + a2;
            }
            break;

        case 2: // Double sash
        case 13:
        case 14:
            {
                const aInner = a - w0 - w3 / 2;
                const a0 = (b * 2 - w1 - w2) * w0;
                const a1 = aInner * w1;
                const a2 = aInner * w2;
                const a3 = (b - w1 / 2 - w2 / 2) * w3;
                frameArea = a0 + a1 + a2 + a3;
            }
            break;

        case 3: // Two parted fixed/turn/tilt
            {
                const a1 = a / 2 - w0 / 2 - w6 / 4;
                const a2 = a / 2 - w3 / 2 - w6 / 4;
                const a0 = (b - w1 / 2 - w2 / 2) * w0;
                const a1Area = a1 * w1;
                const a2Area = a1 * w2;
                const a3 = (b - w4 / 2 - w5 / 2) * w3;
                const a4 = a2 * w4;
                const a5 = a2 * w5;
                const a6 = b * w6 - (w6 / 4) * (w1 + w2 + w4 + w5);
                frameArea = a0 + a1Area + a2Area + a3 + a4 + a5 + a6;
            }
            break;

        case 4: // Triple sash
            {
                const aInner = a - w0 / 2 - w4 / 2 - w5 / 2 - w1 / 2;
                const bInner = b - w2 / 2 - w3 / 2;
                const a0 = bInner * w0;
                const a1 = bInner * w1;
                const a2 = aInner * w2;
                const a3 = aInner * w3;
                const a4 = bInner * w4;
                const a5 = bInner * w5;
                frameArea = a0 + a1 + a2 + a3 + a4 + a5;
            }
            break;

        case 5: // Vertical sliding sash
            {
                const ab = a - w2;
                const a0 = (c * 2 - w1) * w0;
                const a1 = (a - w0) * w1;
                const a2 = (b * 2 - w3 - w4) * w2;
                const a3 = ab * w3;
                const a4 = ab * w4;
                frameArea = a0 + a1 + a2 + a3 + a4;
            }
            break;

        case 6: // Horizontal sliding sash
            {
                const aInner = a - w0 / 2 - w6 / 4;
                const bInner = b - w3 / 2 - w6 / 4;
                const a0 = (c - w1 / 2 - w2 / 2) * w0;
                const a1 = aInner * w1;
                const a2 = aInner * w2;
                const a3 = (c - w4 / 2 - w5 / 2) * w3;
                const a4 = bInner * w4;
                const a5 = bInner * w5;
                const a6 = c * w6 - (w6 / 4) * (w1 + w2 + w4 + w5);
                frameArea = a0 + a1 + a2 + a3 + a4 + a5 + a6;
            }
            break;

        case 7: // Single sash with toplight
            {
                const ac = a - w0;
                const ab = a - w2;
                const a0 = c * w0 * 2 - w0 * w1 - (w0 * w3) / 2;
                const a1 = ac * w1;
                const a2 = b * w2 * 2 - w2 * (w3 / 2) - w2 * w4;
                const a3 = a * w3 - (w0 + w2) * (w3 / 2);
                const a4 = ab * w4;
                frameArea = a0 + a1 + a2 + a3 + a4;
            }
            break;

        case 8: // Double sash with toplight
            {
                const ac = a - w0;
                const ab = a - w2;
                const a0 = c * w0 * 2 - w0 * w1 - (w0 * w3) / 2;
                const a1 = ac * w1;
                const a2 = b * w2 * 2 - w2 * (w3 / 2) - w2 * w4;
                const a3 = a * w3 - (w0 + w2 + w5 / 2) * (w3 / 2);
                const a4 = (ab - w5 / 2) * w4;
                const a5 = b * w5 - (w3 / 4 + w4 / 2) * w5;
                frameArea = a0 + a1 + a2 + a3 + a4 + a5;
            }
            break;

        case 10: // Cross
            {
                const aInner = a - w0 - w3 / 2;
                const a0 = (b * 2 - w1 - w2 - w3) * w0;
                const a1 = aInner * w1;
                const a2 = aInner * w2;
                const a3 = (a + b - w0 - w1 / 2 - w2 / 2 - w3) * w3;
                frameArea = a0 + a1 + a2 + a3;
            }
            break;

        case 11: // Double sash right split
            {
                const aInner = a - w0 - w3 / 2;
                const a0 = ((b + c) * 2 - w1 - w2 - w4 / 2) * w0;
                const a1 = aInner * w1;
                const a2 = aInner * w2;
                const a3 = (b + c - w1 / 2 - w2 / 2 - w4 / 4) * w3;
                const a4 = (a / 2 - w0 / 2 - w3 / 4) * w4;
                frameArea = a0 + a1 + a2 + a3 + a4;
            }
            break;

        case 12: // Triple sash middle split
            {
                const aInner = a - w0 / 2 - w1 / 2 - w4 / 2 - w5 / 2;
                const bc = b + c - w2 / 2 - w3 / 2;
                const a0 = bc * w0;
                const a1 = bc * w1;
                const a2 = aInner * w2;
                const a3 = aInner * w3;
                const a4 = (bc - w6 / 4) * w4;
                const a5 = (bc - w6 / 4) * w5;
                const a6 =
                    ((a - w0 - w1 - w4 - w5) / 3 + w4 / 4 + w5 / 4) * w6;
                frameArea = a0 + a1 + a2 + a3 + a4 + a5 + a6;
            }
            break;

        default:
            // Simple estimation for unknown types
            frameArea = (2 * a + 2 * b) * (w0 || 0.1);
    }

    return frameArea;
}

/**
 * Calculate glass edge length
 * Reference: calculation.js calcGlassEdge()
 */
export function calculateGlassEdge(
    windowTypeId: number,
    dimensions: WindowDimensions,
    frameWidths: FrameWidths
): number {
    const { a, b, c } = dimensions;
    const { w0, w1, w2, w3, w4, w5, w6 } = frameWidths;

    let width = 0;
    let height = 0;

    switch (windowTypeId) {
        case 1: // Single sash
        case 9: // Fixed light
            width = 2 * (a - w0 - w0);
            height = 2 * (b - w1 - w2);
            break;

        case 2: // Double sash
        case 13:
        case 14:
            width = 2 * (a - w0 - w0 - w3);
            height = 4 * (b - w1 - w2);
            break;

        case 3: // Two parted
            width = 2 * (a - w0 - w3 - w6);
            height = 2 * (b - w1 - w2) + 2 * (b - w4 - w5);
            break;

        case 4: // Triple sash
            width = 2 * (a - w0 - w1 - w4 - w5);
            height = 6 * (b - w2 - w3);
            break;

        case 5: // Vertical sliding
            width = 2 * (a - w0 - w0) + 2 * (a - w2 - w2);
            height = 2 * (b - w3 - w4) + 2 * (c - w1);
            break;

        case 6: // Horizontal sliding
            width = 2 * (a + b - w0 - w6 - w3);
            height = 2 * (c - w1 - w2) + 2 * (c - w4 - w5);
            break;

        case 7: // Single sash toplight
            width = 2 * (a - w0 - w0) + 2 * (a - w2 - w2);
            height = 2 * (b - w3 / 2 - w4) + 2 * (c - w1 - w3 / 2);
            break;

        case 8: // Double sash toplight
            width = 2 * (a - w0 - w0) + 2 * (a - w2 - w2 - w5);
            height = 4 * (b - w3 / 2 - w4) + 2 * (c - w3 / 2 - w1);
            break;

        case 10: // Cross
            width = 4 * (a - w0 - w0 - w3);
            height = 4 * (b - w1 - w2 - w3);
            break;

        case 11: // Double split
            width = 2 * (a - w0 - w0 - w3) + 2 * (a / 2 - w0 - w3 / 2);
            height = 2 * (b + c - w1 - w2) + 2 * (b + c - w1 - w2 - w4);
            break;

        case 12: // Triple split
            width =
                2 * (a / 3 - w0 - w4 / 2) +
                4 * (a / 3 - w4 / 2 - w5 / 2) +
                2 * (a / 3 - w1 - w5 / 2);
            height = 4 * (b + c - w2 - w3) + 2 * (b + c - w2 - w3 - w6);
            break;

        default:
            // Default estimation
            width = 2 * (a - 2 * w0);
            height = 2 * (b - w1 - w2);
    }

    return (width + height);
}

/**
 * Calculate muntin length
 * Reference: calculation.js calcMuntinLength()
 */
export function calculateMuntinLength(
    windowTypeId: number,
    dimensions: WindowDimensions,
    frameWidths: FrameWidths,
    muntinType: { id: number },
    muntinShape: { id: number; countHorizontal: number; countVertical: number }
): number {
    // No muntin if shape is type 1
    if (muntinShape.id === 1) {
        return 0;
    }

    const { a, b, c } = dimensions;
    const { w0, w1, w2, w3, w4, w5, w6 } = frameWidths;

    let width = 0;
    let height = 0;

    // Calculate dimensions based on window type
    switch (windowTypeId) {
        case 1: // Single sash
        case 9: // Fixed light
            width = a - w0 - w0;
            height = b - w1 - w2;
            break;

        case 2: // Double sash
        case 13:
        case 14:
            width = a - w0 - w0 - w3;
            height = (b - w1 - w2) * 2;
            break;

        case 3: // Two parted
            width = a - w0 - w3 - w6;
            height = (b - w1 - w2) + (b - w4 - w5);
            break;

        case 4: // Triple sash
            width = a - w0 - w1 - w4 - w5;
            height = (b - w2 - w3) * 3;
            break;

        case 5: // Vertical sliding
            width = a - w0 - w2;
            height = (b - w3 - w4) + (c - w1);
            break;

        case 6: // Horizontal sliding
            width = a + b - w0 - w6 - w3;
            height = (c - w1 - w2) + (c - w4 - w5);
            break;

        case 7: // Single sash toplight
            width = (a - w0 - w0) + (a - w2 - w2);
            height = (b - w4 - w3 / 2) + (c - w1 - w3 / 2);
            break;

        case 8: // Double sash toplight
            width = (w0 + w0) + (a - w2 - w2 - w5);
            height = (b - w4 - w3 / 2) + (c - w1 - w3 / 2);
            break;

        default:
            width = a - 2 * w0;
            height = b - w1 - w2;
    }

    // Apply muntin type factor
    if (muntinType.id === 5) {
        // Double muntin
        width = 2 * width;
        height = 2 * height;
    }

    // Apply shape counts
    width = width * muntinShape.countHorizontal;
    height = height * muntinShape.countVertical;

    let result = width + height;

    // Fixed addition type multiplies by 2
    if (muntinType.id === 4) {
        result = result * 2;
    }

    return result;
}

/**
 * Extract frame widths from frame object
 */
export function extractFrameWidths(frame: any): FrameWidths {
    const w = frame.wValues;

    if (Array.isArray(w) && w.length >= 7) {
        return {
            w0: parseFloat(w[0] || 0),
            w1: parseFloat(w[1] || 0),
            w2: parseFloat(w[2] || 0),
            w3: parseFloat(w[3] || 0),
            w4: parseFloat(w[4] || 0),
            w5: parseFloat(w[5] || 0),
            w6: parseFloat(w[6] || 0)
        };
    }
    // fallback to legacy flat fields
    return {
        w0: parseFloat(frame.w0 || 0),
        w1: parseFloat(frame.w1 || 0),
        w2: parseFloat(frame.w2 || 0),
        w3: parseFloat(frame.w3 || 0),
        w4: parseFloat(frame.w4 || 0),
        w5: parseFloat(frame.w5 || 0),
        w6: parseFloat(frame.w6 || 0)
    };
}

export function calcArea(project: any): number {
    let result = 0;
    const id = project?.windowtype?.id;

    const dimA = project.dimA;
    const dimB = project.dimB;
    const dimC = project.dimC ?? 0;

    if (id < 5 || id === 9 || id === 10 || id === 13 || id === 14) {
        // simple windows (a * b)
        result = dimA * dimB;

    } else if (id === 5 || id === 7 || id === 8 || id === 11 || id === 12) {
        // vertical split windows (a * (b + c))
        result = dimA * (dimB + dimC);

    } else if (id === 6) {
        // horizontal split windows ((a + b) * c)
        result = (dimA + dimB) * dimC;
    }

    project.area = result;
    return result;
}

export function setDefaultDimensions(windowID: number): any {
    let dimensionForm;
    console.log(windowID)
    switch (windowID) {
        // Triple sash
        case 4:
            dimensionForm = {
                dimA: DIMENSION_CONSTANTS.WIDTH_A_DOUB,
                dimB: DIMENSION_CONSTANTS.HEIGHT_B_NORM,
                dimC: 0
            };
            break;

        // Vertical sliding
        case 5:
            dimensionForm = {
                dimA: DIMENSION_CONSTANTS.WIDTH_A_NORM,
                dimB: DIMENSION_CONSTANTS.HEIGHT_B_HALF,
                dimC: DIMENSION_CONSTANTS.HEIGHT_C_HALF
            };;
            break;

        // Horizontal sliding
        case 6:
            dimensionForm = {
                dimA: DIMENSION_CONSTANTS.WIDTH_A_HALF,
                dimB: DIMENSION_CONSTANTS.WIDTH_B,
                dimC: DIMENSION_CONSTANTS.HEIGHT_C_NORM
            };
            break;

        // Single sash toplight
        case 7:
            dimensionForm = {
                dimA: DIMENSION_CONSTANTS.WIDTH_A_NORM,
                dimB: DIMENSION_CONSTANTS.HEIGHT_B_NORM,
                dimC: DIMENSION_CONSTANTS.HEIGHT_C_OHL
            };
            break;

        // Double sash toplight
        case 8:
            dimensionForm = {
                dimA: DIMENSION_CONSTANTS.WIDTH_A_NORM,
                dimB: DIMENSION_CONSTANTS.HEIGHT_B_NORM,
                dimC: DIMENSION_CONSTANTS.HEIGHT_C_OHL
            };
            break;

        // Cross
        case 10:
            dimensionForm = {
                dimA: DIMENSION_CONSTANTS.WIDTH_A_NORM,
                dimB: DIMENSION_CONSTANTS.HEIGHT_B_NORM,
                dimC: 0
            };
            break;

        // Double sash splitted
        case 11:
            dimensionForm = {
                dimA: DIMENSION_CONSTANTS.WIDTH_A_NORM,
                dimB: DIMENSION_CONSTANTS.HEIGHT_B_SPLIT,
                dimC: DIMENSION_CONSTANTS.HEIGHT_C_SPLIT
            };
            break;

        // Triple sash splitted
        case 12:
            dimensionForm = {
                dimA: DIMENSION_CONSTANTS.WIDTH_A_DOUB,
                dimB: DIMENSION_CONSTANTS.HEIGHT_B_SPLIT,
                dimC: DIMENSION_CONSTANTS.HEIGHT_C_SPLIT
            };
            break;

        case 13:
            dimensionForm = {
                dimA: 1.53,
                dimB: 1.48,
                dimC: 0
            };
            break;

        case 14:
            dimensionForm = {
                dimA: 2.18,
                dimB: 2.35,
                dimC: 0
            };
            break;

        // Default for single sash, double sash, two parted, fixed light
        default:
            dimensionForm = {
                dimA: DIMENSION_CONSTANTS.WIDTH_A_NORM,
                dimB: DIMENSION_CONSTANTS.HEIGHT_B_NORM,
                dimC: 0
            };
    }
    return dimensionForm;
}

/**
* Calculate area-weighted Uf = Σ(segment_area × uf_segment) / total_frame_area
*/
export function calculateAreaWeightedUf(
    windowTypeId: number,
    dimensions: WindowDimensions,
    frameWidths: FrameWidths,
    frameUfValues: number[]
): number {
    const { a, b, c } = dimensions;
    const { w0, w1, w2, w3, w4, w5, w6 } = frameWidths;

    let totalUfWeighted = 0;
    let totalFrameArea = 0;

    switch (windowTypeId) {
        case 1: case 9: // Single sash / Fixed light
            {
                const a_ = a - w0;
                const a0 = b * w0 * 2 - w0 * w1 - w0 * w2;
                const a1 = a_ * w1;
                const a2 = a_ * w2;
                totalFrameArea = a0 + a1 + a2;
                totalUfWeighted = a0 * frameUfValues[0] + a1 * frameUfValues[1] + a2 * frameUfValues[2];
            }
            break;

        case 2: case 13: case 14: // Double sash
            {
                const a_ = a - w0 - w3 / 2;
                const a0 = (b * 2 - w1 - w2) * w0;
                const a1 = a_ * w1;
                const a2 = a_ * w2;
                const a3 = (b - w1 / 2 - w2 / 2) * w3;
                totalFrameArea = a0 + a1 + a2 + a3;
                totalUfWeighted = a0 * frameUfValues[0] + a1 * frameUfValues[1] + a2 * frameUfValues[2] + a3 * frameUfValues[3];
            }
            break;

        case 3: // Two parted
            {
                const a1 = a / 2 - w0 / 2 - w6 / 4;
                const a2 = a / 2 - w3 / 2 - w6 / 4;
                const a0 = (b - w1 / 2 - w2 / 2) * w0;
                const a1Area = a1 * w1;
                const a2Area = a1 * w2;
                const a3 = (b - w4 / 2 - w5 / 2) * w3;
                const a4 = a2 * w4;
                const a5 = a2 * w5;
                const a6 = b * w6 - (w6 / 4) * (w1 + w2 + w4 + w5);
                totalFrameArea = a0 + a1Area + a2Area + a3 + a4 + a5 + a6;
                totalUfWeighted =
                    a0 * frameUfValues[0] + a1Area * frameUfValues[1] + a2Area * frameUfValues[2] +
                    a3 * frameUfValues[3] + a4 * frameUfValues[4] + a5 * frameUfValues[5] + a6 * frameUfValues[6];
            }
            break;

        case 4: // Triple sash
            {
                const a_ = a - w0 / 2 - w4 / 2 - w5 / 2 - w1 / 2;
                const b_ = b - w2 / 2 - w3 / 2;
                const a0 = b_ * w0;
                const a1 = b_ * w1;
                const a2 = a_ * w2;
                const a3 = a_ * w3;
                const a4 = b_ * w4;
                const a5 = b_ * w5;
                totalFrameArea = a0 + a1 + a2 + a3 + a4 + a5;
                totalUfWeighted = a0 * frameUfValues[0] + a1 * frameUfValues[1] + a2 * frameUfValues[2] +
                    a3 * frameUfValues[3] + a4 * frameUfValues[4] + a5 * frameUfValues[5];
            }
            break;

        case 5: // Vertical sliding
            {
                const a_b = a - w2;
                const a0 = (c * 2 - w1) * w0;
                const a1 = (a - w0) * w1;
                const a2 = (b * 2 - w3 - w4) * w2;
                const a3 = a_b * w3;
                const a4 = a_b * w4;
                totalFrameArea = a0 + a1 + a2 + a3 + a4;
                totalUfWeighted = a0 * frameUfValues[0] + a1 * frameUfValues[1] + a2 * frameUfValues[2] +
                    a3 * frameUfValues[3] + a4 * frameUfValues[4];
            }
            break;

        case 6: // Horizontal sliding
            {
                const a_ = a - w0 / 2 - w6 / 4;
                const b_ = b - w3 / 2 - w6 / 4;
                const a0 = (c - w1 / 2 - w2 / 2) * w0;
                const a1 = a_ * w1;
                const a2 = a_ * w2;
                const a3 = (c - w4 / 2 - w5 / 2) * w3;
                const a4 = b_ * w4;
                const a5 = b_ * w5;
                const a6 = c * w6 - (w6 / 4) * (w1 + w2 + w4 + w5);
                totalFrameArea = a0 + a1 + a2 + a3 + a4 + a5 + a6;
                totalUfWeighted =
                    a0 * frameUfValues[0] + a1 * frameUfValues[1] + a2 * frameUfValues[2] +
                    a3 * frameUfValues[3] + a4 * frameUfValues[4] + a5 * frameUfValues[5] + a6 * frameUfValues[6];
            }
            break;

        case 7: // Single sash toplight
            {
                const a_c = a - w0;
                const a_b = a - w2;
                const a0 = c * w0 * 2 - w0 * w1 - (w0 * w3) / 2;
                const a1 = a_c * w1;
                const a2 = b * w2 * 2 - w2 * (w3 / 2) - w2 * w4;
                const a3 = a * w3 - (w0 + w2) * (w3 / 2);
                const a4 = a_b * w4;
                totalFrameArea = a0 + a1 + a2 + a3 + a4;
                totalUfWeighted =
                    a0 * frameUfValues[0] + a1 * frameUfValues[1] + a2 * frameUfValues[2] +
                    a3 * frameUfValues[3] + a4 * frameUfValues[4];
            }
            break;

        case 8: // Double sash toplight
            {
                const a_c = a - w0;
                const a_b = a - w2;
                const a0 = c * w0 * 2 - w0 * w1 - (w0 * w3) / 2;
                const a1 = a_c * w1;
                const a2 = b * w2 * 2 - w2 * (w3 / 2) - w2 * w4;
                const a3 = a * w3 - (w0 * w2 * w5) / 2 + (w3 / 2);
                const a4 = (a_b - w5 / 2) * w4;
                const a5 = b * w5 - (w3 / 4) * (w4 / 2) * w5;
                totalFrameArea = a0 + a1 + a2 + a3 + a4 + a5;
                totalUfWeighted =
                    a0 * frameUfValues[0] + a1 * frameUfValues[1] + a2 * frameUfValues[2] +
                    a3 * frameUfValues[3] + a4 * frameUfValues[4] + a5 * frameUfValues[5];
            }
            break;

        case 10: // Cross
            {
                const a_ = a - w0 - w3 / 2;
                const a0 = (b * 2 - w1 - w2 - w3) * w0;
                const a1 = a_ * w1;
                const a2 = a_ * w2;
                const a3 = (a + b - w0 - w1 / 2 - w2 / 2 - w3) * w3;
                totalFrameArea = a0 + a1 + a2 + a3;
                totalUfWeighted =
                    a0 * frameUfValues[0] + a1 * frameUfValues[1] + a2 * frameUfValues[2] + a3 * frameUfValues[3];
            }
            break;

        case 11: // Double split
            {
                const a_ = a - w0 - w3 / 2;
                const a0 = ((b + c) * 2 - w1 - w2 - w4 / 2) * w0;
                const a1 = a_ * w1;
                const a2 = a_ * w2;
                const a3 = (b + c - w1 / 2 - w2 / 2 - w4 / 4) * w3;
                const a4 = (a / 2 - w0 / 2 - w3 / 4) * w4;
                totalFrameArea = a0 + a1 + a2 + a3 + a4;
                totalUfWeighted =
                    a0 * frameUfValues[0] + a1 * frameUfValues[1] + a2 * frameUfValues[2] +
                    a3 * frameUfValues[3] + a4 * frameUfValues[4];
            }
            break;

        case 12: // Triple split
            {
                const a_ = a - w0 / 2 - w1 / 2 - w4 / 2 - w5 / 2;
                const b_c = b + c - w2 / 2 - w3 / 2;
                const a0 = b_c * w0;
                const a1 = b_c * w1;
                const a2 = a_ * w2;
                const a3 = a_ * w3;
                const a4 = (b_c - w6 / 4) * w4;
                const a5 = (b_c - w6 / 4) * w5;
                const a6 = ((a - w0 - w1 - w4 - w5) / 3 + w4 / 4 + w5 / 4) * w6;
                totalFrameArea = a0 + a1 + a2 + a3 + a4 + a5 + a6;
                totalUfWeighted =
                    a0 * frameUfValues[0] + a1 * frameUfValues[1] + a2 * frameUfValues[2] +
                    a3 * frameUfValues[3] + a4 * frameUfValues[4] + a5 * frameUfValues[5] + a6 * frameUfValues[6];
            }
            break;


        default:
            const usedUfs = frameUfValues.filter(v => v > 0);
            return usedUfs.length ? usedUfs.reduce((sum, v) => sum + v, 0) / usedUfs.length : 0;
    }

    return totalFrameArea > 0 ? parseFloat((totalUfWeighted / totalFrameArea).toFixed(3)) : 0;
}

